import { Button } from '@vtex/shoreline'
import { FiAlertCircle } from 'react-icons/fi'
import { t } from 'i18next'

import { useSpendOverview, isNotFoundError } from '~/modules/retailMedia/hooks/useSpendReports'

import { PacingCard } from './index'
import PacingCardSkeleton from './PacingCardSkeleton'
import styles from './styles.module.css'

const OverviewCards = ({
  campaignId,
  dateRange
}: {
  campaignId: string
  dateRange: { start_date: string; end_date: string }
}) => {
  const { data, isPending, error, refetch } = useSpendOverview(campaignId, dateRange)

  if (error) {
    return (
      <div className={styles.errorCard}>
        <FiAlertCircle size={32} color="#707070" />
        <span>
          {isNotFoundError(error)
            ? t('rm:spendReport.error.noData')
            : t('rm:spendReport.error.loadFailed')}
        </span>
        {!isNotFoundError(error) && <Button onClick={() => refetch()}>{t('rm:spendReport.retry')}</Button>}
      </div>
    )
  }

  if (isPending || !data) {
    return (
      <div className={styles.grid}>
        <PacingCardSkeleton />
        <PacingCardSkeleton />
        <PacingCardSkeleton />
        <PacingCardSkeleton />
      </div>
    )
  }

  const today = new Date().toISOString().split('T')[0]
  const isFinished = !!data.campaign_end_at && data.campaign_end_at < today

  const thirdMetric = data.monthly ?? data.total
  const fourthMetric = data.monthly_forecast ?? data.forecast
  const thirdTitle = data.campaign_end_at
    ? t('rm:spendReport.card.total')
    : t('rm:spendReport.card.monthly')
  const fourthTitle = data.monthly_forecast || !data.campaign_end_at
    ? t('rm:spendReport.card.monthly_forecast')
    : t('rm:spendReport.card.forecast')

  return (
    <div className={styles.grid}>
      <PacingCard
        title={isFinished ? t('rm:spendReport.card.last_day') : t('rm:spendReport.card.daily')}
        metric={data.daily}
        currency={data.currency}
        progressVariant="consumption"
      />
      <PacingCard
        title={isFinished ? t('rm:spendReport.card.last_week') : t('rm:spendReport.card.weekly')}
        metric={data.weekly}
        currency={data.currency}
        progressVariant="consumption"
      />
      <PacingCard
        title={thirdTitle}
        metric={thirdMetric}
        currency={data.currency}
        progressVariant="consumption"
      />
      {!isFinished && (
        <PacingCard
          title={fourthTitle}
          metric={fourthMetric}
          currency={data.currency}
          progressVariant="forecast"
        />
      )}
    </div>
  )
}

export default OverviewCards
